import React from "react";

const sizes = {
  s: "text-2xl font-bold",
  md: "text-4xl font-semibold",
  xs: "text-[17px] font-bold leading-[120%]",
  lg: "text-5xl font-bold",
};

const Heading = ({ children, className = "", size = "lg", as, ...restProps }) => {
  const Component = as || "h6";

  return (
    <Component className={`text-black-900 font-poppins ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Heading };
